import moment from 'moment';
import momentTimezone from 'moment-timezone';

export const TIME_FORMAT = 'HH:mm';
export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm';
export const DATETIME_SECONDS_FORMAT = 'YYYY-MM-DD HH:mm:ss';

/**
 * Check if date is between range - start_date / end_date
 * @param date
 * @param datesObject
 * @returns {boolean}
 */
export const checkDateRange = (date, datesObject) => {
    date = transformMomentDatetimeToDate(date);

    return (date.isSameOrAfter(datesObject.start_date) && date.isSameOrBefore(datesObject.end_date));
};

export const transformMomentDatetimeToDate = (date) => {
    const momentObject = !moment.isMoment(date) ? moment(date) : date;

    momentObject.set({
        'hour': 0,
        'minute': 0,
        'second': 0,
    });

    return momentObject;
};

export const getTodayDate = () => (
    moment().format('YYYY-MM-DD 00:00')
);

export const getTomorrowDate = () => (
    moment().add(1, 'day').format('YYYY-MM-DD 00:00')
);

export const getEndOfTodayDate = () => (
    moment()
        .add(1, 'day')
        .startOf('day')
        .subtract(1, 'minute')
        .format(DATETIME_FORMAT)
);

export const getSixMonthsAgoDate = () => (
    moment().subtract(6, 'months').format('YYYY-MM-DD 00:00')
);

export const getOneHourAgoDateTime = () => (
    moment().subtract(1, 'hours').format(DATETIME_FORMAT)
);

export const getLastMinuteOfToday = () => (
    moment().hours(23).minutes(59)
);

export const dateEmpty = (from, to) => !from || !to;

export const formatMicrosecondsToDateTime = (microseconds, timezone) => {
    if (!microseconds) {
        return '';
    }

    const nanoseconds = microseconds * 1000;
    const format = DATETIME_SECONDS_FORMAT;

    if (timezone && momentTimezone && 'function' === typeof momentTimezone.tz) {
        return momentTimezone.utc(nanoseconds).tz(timezone).format(format);
    }

    return moment.utc(nanoseconds).format(format);
};

export const formatFromUtcTimezone = (datetime, timezone) => {
    if (!datetime) {
        return '';
    }

    const format = DATETIME_SECONDS_FORMAT;

    if (timezone && momentTimezone && 'function' === typeof momentTimezone.tz) {
        return momentTimezone.utc(datetime).tz(timezone).format(format);
    }

    return moment.utc(datetime).format(format);
};

export const formatDateWithoutSeconds = (dateString) => (
    moment(dateString).format(DATETIME_FORMAT)
);

export const addDaysToDate = (date, days) => (
    moment(date).add(days, 'd').format(DATETIME_FORMAT)
);

export const subtractDaysFromDate = (date, days) => (
    moment(date).subtract(days, 'd').format(DATETIME_FORMAT)
);

export const isWithinLastMonths = (datetime, months) => {
    if (!datetime) {
        return false;
    }

    return moment(datetime).isAfter(moment().subtract(months, 'months'));
};
